// js/core/Route.js
// 玩家畫出的路線（導航意圖）。從黎先生起點出發的連續折線。
// 逐段驗證：不穿越陸地、不落在陸地內、總長 ≤ maxRouteLength（超過則裁切）。

import { dist, segCrossesPoly, pointInPoly } from '../util/geom.js';

export class Route {
  constructor(start, maxLen, terrain) {
    this.start = { ...start };
    this.maxLen = maxLen;
    this.terrain = terrain || [];
    this.points = [{ ...start }];
    this.length = 0;
    this.blocked = false; // 上次 extend 是否被地形擋住（給 UI 提示用）
  }

  clear() {
    this.points = [{ ...this.start }];
    this.length = 0;
    this.blocked = false;
  }

  // 段是否會穿入地形
  _crossesTerrain(ax, ay, bx, by) {
    const mx = (ax + bx) / 2, my = (ay + by) / 2;
    for (const poly of this.terrain) {
      if (segCrossesPoly(ax, ay, bx, by, poly)) return true;
      if (pointInPoly(mx, my, poly)) return true;
    }
    return false;
  }

  // 嘗試把點 p 接上末端；回傳是否成功。超過預算則沿方向裁切到上限。
  extend(p) {
    const last = this.points[this.points.length - 1];
    const d = dist(last.x, last.y, p.x, p.y);
    if (d < 0.001) { this.blocked = false; return false; }
    if (this._crossesTerrain(last.x, last.y, p.x, p.y)) {
      this.blocked = true;
      return false;
    }
    this.blocked = false;
    if (this.length + d > this.maxLen) {
      const remain = this.maxLen - this.length;
      if (remain <= 0.001) return false;
      const t = remain / d;
      this.points.push({ x: last.x + (p.x - last.x) * t, y: last.y + (p.y - last.y) * t });
      this.length = this.maxLen;
      return true;
    }
    this.points.push({ x: p.x, y: p.y });
    this.length += d;
    return true;
  }
}
